import React from "react";
import { PageHero } from "@/components/site/ui";
import { Reveal } from "@/components/brand";

export default function StaticPage({ title, eyebrow, sections }) {
  return (
    <div>
      <PageHero eyebrow={eyebrow} title={title} compact />
      <div className="max-w-3xl mx-auto px-6 py-16 space-y-8">
        {sections.map((s, i) => (
          <Reveal key={i} delay={i * 0.05}>
            {s.h && <h2 className="font-serif text-2xl text-gold mb-2">{s.h}</h2>}
            <p className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line">{s.p}</p>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
